(function () {
  const animateOnScroll = (section) => {
    if (
      !section ||
      !section?.classList.contains("collections-list-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const animateTitles = () => {
      const titles = section.querySelector(".collections-list-titles");

      if (!titles) return;

      ScrollTrigger.create({
        trigger: titles,
        start: "top 80%",
        end: "bottom top",
        onEnter: () => {
          titles.classList.add("animated");
        },
      });
    };

    const animateImages = () => {
      const images = section.querySelectorAll(".collections-list-image");

      if (!images.length) return;

      images.forEach((image) => {
        ScrollTrigger.create({
          trigger: image,
          start: "50% 90%",
          end: "bottom top",
          onEnter: () => {
            image.classList.add("animated");
          },
        });
      });
    };

    animateImages();
    animateTitles();
  };

  const updateCountsExcludingTag = (section) => {
    if (!section || !section.classList.contains("collections-list-section")) return;

    // Read settings from Liquid data-attributes (fallbacks included)
    const root = section.querySelector(".collections-list");
    const enabledRaw = root?.dataset?.excludeTaggedFromCount;
    const enabled =
      enabledRaw === "true" || enabledRaw === "1" || enabledRaw === "enabled";
    const excludeTag = (root?.dataset?.excludeTagFromCount || "collection")
      .trim()
      .toLowerCase();

    if (!enabled || !excludeTag) return;

    // Prevent duplicate concurrent inits (but allow re-run after section re-render)
    if (section.__cl_exclude_count_running) return;
    section.__cl_exclude_count_running = true;

    const parseHandleFromUrl = (url) => {
      try {
        const u = new URL(url, window.location.origin);
        const parts = u.pathname.split("/").filter(Boolean);
        const idx = parts.indexOf("collections");
        if (idx === -1) return null;
        return parts[idx + 1] || null;
      } catch (e) {
        return null;
      }
    };

    const setCountText = (countEl, count) => {
      if (!countEl) return;

      // One-image layout uses inner ".collections-list-titles-item__count-value" with parentheses + leading 0
      const inner = countEl.querySelector(".collections-list-titles-item__count-value");
      if (inner) {
        const padded = count < 10 ? `0${count}` : `${count}`;
        inner.textContent = `(${padded})`;
        return;
      }

      // Two-images layout uses the count element directly, usually "(X)"
      countEl.textContent = `(${count})`;
    };

    const getCountEls = () => {
      // Works for both layouts (div and li variants)
      return Array.from(section.querySelectorAll(".collections-list-titles-item")).map((item) => {
        const link = item.querySelector(".collections-list-titles-item__link");
        const countEl = item.querySelector(".collections-list-titles-item__count");
        const href = link?.getAttribute("href") || "";
        return { item, href, countEl };
      });
    };

    // Cache filtered counts per collection+tag (fast on repeated loads / theme editor re-renders)
    const CACHE_TTL_MS = 10 * 60 * 1000; // 10 minutes
    const cacheKey = (handle) => `cl_exclcount:${handle}:${excludeTag}`;

    const getCached = (handle) => {
      try {
        const raw = sessionStorage.getItem(cacheKey(handle));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed.count !== "number" || typeof parsed.ts !== "number") return null;
        if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
        return parsed.count;
      } catch (e) {
        return null;
      }
    };

    const setCached = (handle, count) => {
      try {
        sessionStorage.setItem(cacheKey(handle), JSON.stringify({ count, ts: Date.now() }));
      } catch (e) {}
    };

    const fetchAllProducts = async (handle) => {
      const cached = getCached(handle);
      if (cached !== null) return cached;

      // NOTE: /collections/{handle}/products.json does NOT include product tags in your store.
      // Workaround: fetch each product's tags via /products/{product-handle}.js
      const limit = 250;
      let page = 1;
      let filteredCount = 0;

      const extraParams = window.location.search ? window.location.search.replace(/^\?/, "&") : "";
      const maxPages = 20; // safety cap

      const pool = async (items, worker, concurrency = 4) => {
        const queue = items.slice();
        const runners = Array.from({ length: Math.min(concurrency, queue.length) }, async () => {
          while (queue.length) {
            const item = queue.shift();
            await worker(item);
          }
        });
        await Promise.all(runners);
      };

      while (page <= maxPages) {
        const res = await fetch(`/collections/${handle}/products.json?limit=${limit}&page=${page}${extraParams}`, {
          credentials: "same-origin",
          headers: { "Accept": "application/json" },
        });

        if (!res.ok) break;

        const data = await res.json();
        const products = Array.isArray(data?.products) ? data.products : [];
        if (!products.length) break;

        const handles = products.map((p) => p?.handle).filter(Boolean);

        await pool(handles, async (productHandle) => {
          try {
            const pRes = await fetch(`/products/${productHandle}.js${window.location.search || ""}`, {
              credentials: "same-origin",
              headers: { "Accept": "application/json" },
            });
            if (!pRes.ok) return;

            const pData = await pRes.json();
            const tags = Array.isArray(pData?.tags)
              ? pData.tags.map((t) => String(t).trim().toLowerCase())
              : [];

            if (!tags.includes(excludeTag)) filteredCount += 1;
          } catch (e) {}
        });

        if (products.length < limit) break;
        page += 1;
      }

      setCached(handle, filteredCount);
      return filteredCount;
    };



    (async () => {
      try {
        const targets = getCountEls();

        // Only process items that actually have a count element rendered
        const jobs = targets
          .filter((t) => t.countEl && t.href)
          .map(async (t) => {
            const handle = parseHandleFromUrl(t.href);
            if (!handle) return;

            // Store original count once (so toggling off later is possible without refetch)
            if (!t.countEl.dataset.originalCount) {
              const raw = t.countEl.textContent || "";
              const num = parseInt(raw.replace(/[^\d]/g, ""), 10);
              if (Number.isFinite(num)) t.countEl.dataset.originalCount = String(num);
            }

            const filtered = await fetchAllProducts(handle);
            setCountText(t.countEl, filtered);


          });

        await Promise.all(jobs);
      } catch (e) {
        // Fail silently (counts are non-critical UI)
      } finally {
        section.__cl_exclude_count_running = false;
      }
    })();
  };

  // Collection previews are independent of product-card media. Shopify renders
  // their posters immediately; video sources remain detached until the active
  // collection is visible. A prepared source stays attached for return visits.
  const getCollectionMedia = (section) => {
    if (!section || !section.classList.contains("collections-list-section")) return null;
    if (section.__vcCollectionMedia) return section.__vcCollectionMedia;

    const videos = Array.from(section.querySelectorAll("video.collections-list-video"));
    let activeIndex = 0;
    let inView = false;

    // Homepage mobile needs a still independent of the native video poster.
    // Reuse the exact poster URL for the selected collection.
    const isMobileHomepage = () =>
      window.matchMedia("(max-width: 749px)").matches &&
      (window.location.pathname === "/" || section.classList.contains("vc-family-showcase-section"));

    const ensureMobileStills = () => {
      if (!isMobileHomepage()) return;
      section.classList.add("vc-mobile-showcase-handoff");
      videos.forEach((video) => {
        const wrapper = video.closest(".collections-list-image-wrapper");
        if (!wrapper || video.dataset.vcStillReady === "true" || !video.poster) return;
        video.dataset.vcStillReady = "true";

        const still = document.createElement("img");
        still.className = "vc-showcase-still";
        still.alt = "";
        still.setAttribute("aria-hidden", "true");
        still.decoding = "async";
        still.loading = "eager";
        still.draggable = false;
        still.style.objectFit = video.style.objectFit || "cover";
        still.src = video.poster;
        video.insertAdjacentElement("afterend", still);

        const index = Number(wrapper.dataset.collectionsListIndex);
        const isCurrent = () => inView && activeIndex === index && !video.paused && video.readyState >= 2;
        const reveal = () => {
          // Ignore stale callbacks from an earlier swipe.
          if (!isCurrent()) return;
          requestAnimationFrame(() => requestAnimationFrame(() => {
            if (isCurrent()) wrapper.classList.add("vc-showcase-has-frame");
          }));
        };
        video.addEventListener("playing", () => {
          if (video.requestVideoFrameCallback) {
            video.requestVideoFrameCallback((_now, frame) => {
              if (frame.presentedFrames > 0) reveal();
            });
          } else {
            video.addEventListener("timeupdate", () => {
              if (!wrapper.classList.contains("vc-showcase-has-frame")) reveal();
            });
          }
        });
        video.addEventListener("emptied", () => wrapper.classList.remove("vc-showcase-has-frame"));
        video.addEventListener("error", () => wrapper.classList.remove("vc-showcase-has-frame"));
      });
    };

    const sync = () => {
      ensureMobileStills();
      videos.forEach((video) => {
        const wrapper = video.closest(".collections-list-image-wrapper");
        const index = Number(wrapper?.dataset.collectionsListIndex);
        if (!inView || index !== activeIndex) {
          video.pause();
          return;
        }

        if (video.dataset.vcSourceAttached !== "true") {
          const deferred = video.querySelectorAll("source[data-vc-src]");
          deferred.forEach((source) => source.setAttribute("src", source.dataset.vcSrc));
          if (deferred.length) video.load();
          video.dataset.vcSourceAttached = "true";
        }
        if (video.paused) {
          const requestedIndex = activeIndex;
          const playing = video.play();
          if (playing && typeof playing.then === "function") {
            playing.then(() => {
              if (!inView || activeIndex !== requestedIndex) video.pause();
            }).catch(() => {
              if (isMobileHomepage() && inView && activeIndex === requestedIndex) {
                wrapper.classList.remove("vc-showcase-has-frame");
              }
            });
          }
        }
      });
    };

    const observer = new IntersectionObserver((entries) => {
      inView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.05);
      sync();
    }, { threshold: [0, 0.05] });
    observer.observe(section);

    section.__vcCollectionMedia = {
      activate(index) {
        if (!Number.isFinite(index)) return;
        activeIndex = index;
        sync();
      },
      disconnect() {
        observer.disconnect();
        videos.forEach((video) => video.pause());
      }
    };
    return section.__vcCollectionMedia;
  };

  const hoverToggle = (section) => {

    const media = getCollectionMedia(section);

    const titles = section.querySelectorAll(".collections-list-titles-item");
    const images = section.querySelectorAll(".collections-list-image-wrapper");

    if (!titles.length || !images.length) return;

    const toggleActive = (title) => {
      for (const el of titles) el.classList.remove("active");
      for (const el of images) el.classList.remove("active");

      title.classList.add("active");

      const index = +title.dataset.collectionsListIndex;

      if (isNaN(index) || index < 0 || index >= images.length) return;

      images.forEach((image) => {
        const imageIndex = +image.dataset.collectionsListIndex;

        if (isNaN(imageIndex) || imageIndex < 0 || imageIndex >= images.length)
          return;

        if (imageIndex === index) image.classList.add("active");
      });
      media?.activate(index);
    };

    for (const title of titles) {
      const handleMouseOver = () => toggleActive(title);
      let isInit = false;

      if (window.innerWidth >= 750) {
        title.addEventListener("mouseover", handleMouseOver);
        isInit = true;
      } else {
        title.removeEventListener("mouseover", handleMouseOver);
        isInit = false;
      }

      window.addEventListener("resize", () => {
        if (window.innerWidth >= 750 && !isInit) {
          title.addEventListener("mouseover", handleMouseOver);
          isInit = true;
        } else if (window.innerWidth < 750 && isInit) {
          title.removeEventListener("mouseover", handleMouseOver);
          isInit = false;
        }
      });
    }
  };

  hoverToggle(document.currentScript.parentElement);
  updateCountsExcludingTag(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (e) {
    hoverToggle(e.target);
    updateCountsExcludingTag(e.target);
  });

  (function () {
    let imagesSlider;
    let titlesSlider;

    const initSliders = (section) => {
      const initImagesSlider = () => {
        const imagesSliderEl = section.querySelector(
          ".collections-list-images-container--1"
        );

        if (!imagesSliderEl) return;

        const imagesSliderElWrapper = imagesSliderEl.querySelector(
          ".collections-list-images"
        );
        const imagesSliderElSlides = imagesSliderEl.querySelectorAll(
          ".collections-list-image-wrapper"
        );

        imagesSliderEl.classList.add("swiper");
        imagesSliderElWrapper.classList.add("swiper-wrapper");

        imagesSliderElSlides.forEach((slide) => {
          slide.classList.add("swiper-slide");
        });

        const spaceBetween = imagesSliderEl.classList.contains(
          "collections-list-images-container--visible-overflow"
        )
          ? 16
          : 20;

        const slidesPerView = imagesSliderEl.classList.contains(
          "collections-list-images-container--visible-overflow"
        )
          ? "auto"
          : 1;

        imagesSlider = new Swiper(imagesSliderEl, {
          loop: false,
          autoplay: false,
          a11y: { slideRole: 'link' },
          slidesPerView: slidesPerView,
          allowTouchMove: true,
          spaceBetween: spaceBetween,
          speed: 1000,
        });
      };

      const initTitlesSlider = () => {
        const titlesSliderEl = section.querySelector(
          ".collections-list-titles-container"
        );
        const titlesSliderElWrapper = titlesSliderEl.querySelector(
          ".collections-list-titles"
        );
        const titlesSliderElSlides = titlesSliderEl.querySelectorAll(
          ".collections-list-titles-item"
        );

        if (!titlesSliderEl || !titlesSliderElWrapper || !titlesSliderElSlides)
          return;

        titlesSliderEl.classList.add("swiper");
        titlesSliderElWrapper.classList.add("swiper-wrapper");

        titlesSliderElSlides.forEach((slide) => {
          slide.classList.add("swiper-slide");
        });

        const nextBtnEl = section.querySelector(
          ".collections-list-button--next"
        );
        const prevBtnEl = section.querySelector(
          ".collections-list-button--prev"
        );

        const spaceBetween = titlesSliderEl.classList.contains(
          "collections-list-titles-container--visible-overflow"
        )
          ? 16
          : 20;

        const slidesPerView = titlesSliderEl.classList.contains(
          "collections-list-titles-container--visible-overflow"
        )
          ? "auto"
          : 1;

        titlesSlider = new Swiper(titlesSliderEl, {
          loop: false,
          autoplay: false,
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          speed: 1000,
          allowTouchMove: true,
          controller: {
            control: imagesSlider,
          },
          navigation: {
            nextEl: nextBtnEl,
            prevEl: prevBtnEl,
            disabledClass: "collections-list-button--disabled",
          },
        });
      };

      initImagesSlider();
      initTitlesSlider();

      if (titlesSlider && imagesSlider) {
        const setActiveByIndex = (idx) => {
          const titles = section.querySelectorAll(".collections-list-titles-item");
          const images = section.querySelectorAll(".collections-list-image-wrapper");

          titles.forEach((el) => {
            el.classList.toggle("active", +el.dataset.collectionsListIndex === idx);
          });

          images.forEach((el) => {
            el.classList.toggle("active", +el.dataset.collectionsListIndex === idx);
          });
        };

        const syncActiveAndVideos = () => {
          const activeSlide = imagesSlider.slides?.[imagesSlider.activeIndex];
          const idxFromSlide = activeSlide ? +activeSlide.dataset.collectionsListIndex : imagesSlider.activeIndex;
          const idx = Number.isFinite(idxFromSlide) ? idxFromSlide : imagesSlider.activeIndex;

          setActiveByIndex(idx);
          getCollectionMedia(section)?.activate(idx);
        };

        titlesSlider.controller.control = imagesSlider;
        imagesSlider.controller.control = titlesSlider;

        // Keep state + video playback in sync on mobile swipe / arrows
        if ((window.location.pathname === "/" || section.classList.contains("vc-family-showcase-section")) && window.matchMedia("(max-width: 749px)").matches) {
          imagesSlider.on("slideChange", syncActiveAndVideos);
          titlesSlider.on("slideChange", syncActiveAndVideos);
        }
        imagesSlider.on("slideChangeTransitionEnd", syncActiveAndVideos);
        titlesSlider.on("slideChangeTransitionEnd", syncActiveAndVideos);

        // Initial sync after Swiper mounts
        requestAnimationFrame(syncActiveAndVideos);
      }

    };

    const destroySliders = (section) => {
      titlesSlider.destroy(true, true);
      titlesSlider = null;

      imagesSlider.destroy(true, true);
      imagesSlider = null;

      const swipers = section.querySelectorAll(".swiper");
      const swiperWrappers = section.querySelectorAll(".swiper-wrapper");
      const slides = section.querySelectorAll(".swiper-slide");

      swipers.forEach((el) => {
        el.classList.remove("swiper");
        el.removeAttribute("style");
      });

      swiperWrappers.forEach((el) => {
        el.classList.remove("swiper-wrapper");
        el.removeAttribute("style");
      });

      slides.forEach((el) => {
        el.classList.remove("swiper-slide");
        el.removeAttribute("style");
      });
    };

    const initButtons = (section) => {
      if (!section || !section?.classList.contains("testimonials-section"))
        return;

      const prevButton = section.querySelector(
        ".testimonials-slider-button--prev"
      );
      const nextButton = section.querySelector(
        ".testimonials-slider-button--next"
      );

      if (!prevButton || !nextButton) return;

      let isBtnsInit = false;

      if (
        window.innerWidth < 1200 ||
        !window.matchMedia("(pointer:fine)").matches
      ) {
        prevButton.addEventListener("click", () => {
          mainSlider.slidePrev();
        });

        nextButton.addEventListener("click", () => {
          mainSlider.slideNext();
        });

        isBtnsInit = true;
      }

      window.addEventListener("resize", () => {
        if (
          window.innerWidth < 1200 ||
          !window.matchMedia("(pointer:fine)").matches
        ) {
          if (!isBtnsInit) {
            prevButton.addEventListener("click", () => {
              mainSlider.slidePrev();
            });

            nextButton.addEventListener("click", () => {
              mainSlider.slideNext();
            });

            isBtnsInit = true;
          }
        } else {
          if (isBtnsInit) {
            prevButton.removeEventListener("click", () => {
              mainSlider.slidePrev();
            });

            nextButton.removeEventListener("click", () => {
              mainSlider.slideNext();
            });

            isBtnsInit = false;
          }
        }
      });
    };

    const initCollectionsListSliders = (section) => {
      if (!section || !section?.classList.contains("collections-list-section"))
        return;

      if (window.innerWidth < 750) {
        initSliders(section);
      } else if (imagesSlider || titlesSlider) {
        destroySliders(section);
      }

      let lastWidth = section.getBoundingClientRect().width;

      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const currentWidth = entry.contentRect.width;
          if (currentWidth !== lastWidth) {
            lastWidth = currentWidth;
            if (currentWidth < 750) {
              initSliders(section);
            } else if (imagesSlider || titlesSlider) {
              destroySliders(section);
            }
          }
        }
      });

      resizeObserver.observe(section);
    };

    initCollectionsListSliders(document.currentScript.parentElement);
    initButtons(document.currentScript.parentElement);
    animateOnScroll(document.currentScript.parentElement);

    document.addEventListener("shopify:section:load", function (event) {
      initCollectionsListSliders(event.target);
      initButtons(event.target);
      animateOnScroll(event.target);
    });
    document.addEventListener("shopify:section:unload", function (event) {
      event.target.__vcCollectionMedia?.disconnect();
      delete event.target.__vcCollectionMedia;
    });
  })();
})();
